module.exports = __webpack_public_path__ + "static/img/room3.e611caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/room3.jpg
// module id = hNa9
// module chunks = 1